<template>
  <div>
    <b-container fluid>
      <h1>Manage Request Approvers</h1>

       <b-row>
          <b-col cols="12" lg="4">
            <BaseTextInput v-model="criteria.requestId" 
              :v="$v.criteria.requestId"
              label="MDH Tracking ID"
              tip=""
              slug="requestId"/>
          </b-col>
      </b-row>
      <b-row>
          <b-col>
              <b-button type="button" variant="primary" @click="submit">
                  <b-spinner small v-show="loading" class="mr-2"></b-spinner>
                  Submit
              </b-button>
          </b-col>
      </b-row>
      <hr/>

      <div v-if="approversLoaded">
    
     <div class="card" header-bg-variant="primary" header-text-variant="white">
        <div class="card-header">Request Approvers</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12" lg="6">
                    <BaseEmployeeSelector v-model="divDirector.approver"
                        label="Division Director"
                        :v="$v.divDirector.approver"
                        tip="Enter employee’s last or first name or PCN to narrow list"
                        :showPcn="true"/>
                        <BaseSelector v-model="divDirector.approvalStatus"
                                :v="$v.divDirector.approvalStatus"
                                label="Approval Decision"
                                slug="approvalDecision"
                                :options = approvalStatusOptions />
              
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseEmployeeSelector v-model="asstCommissioner.approver"
                        label="Assistant Commissioner"
                        :v="$v.asstCommissioner.approver"
                        :messages="approverMessages"
                        tip="Enter employee’s last or first name or PCN to narrow list"
                        :showPcn="true"/>
                    <BaseSelector v-model="asstCommissioner.approvalStatus"
                                :v="$v.asstCommissioner.approvalStatus"
                                label="Approval Decision"
                                slug="approvalDecision"
                                :options = approvalStatusOptions />
                </b-col>
            </b-row>
                 <b-row>
          <b-col>
              <b-button type="button" variant="primary" @click="update">
                  <b-spinner small v-show="loading" class="mr-2"></b-spinner>
                  Update
              </b-button>
          </b-col>
      </b-row>
        </div>
    </div>
    </div>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf, ref, minValue, maxValue } from 'vuelidate/lib/validators'
import _ from "lodash"
import pageTitle from '@/mixins/pageTitle'

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
    title: 'Manage Request Approvers',
    mixins: [pageTitle],
    data: () => ({
      loading: false, 
      approversLoaded: false,
      submitter: null,
      supervisor: null,
      criteria: {
        requestId: null, 
      },
      approvers: [],
      approvalStatusOptions: [
          { value: ' ', text: ' Waiting on other Approver' },
          { value: 'P', text: 'Pending' },
          { value: 'A', text: 'Approved' },
          { value: 'R', text: 'Rejected' },
      ],
      divDirector: {
          id: null, 
          approvalStatus: '',
          approvalStatusDatetime: null,
          approvalType: 'DD',
          approver: {
              userId: '',
              name: '',
              email: '',
          }
      },
      asstCommissioner: {
          id: null, 
          approvalStatus: '',
          approvalStatusDatetime: null,
          approvalType: 'AC',
          approver: {
              userId: '',
              name: '',
              email: '',
          }
      },
      approverMessages: {approverValid: 'The 2nd approver cannot be the same as 1st Approver if they are also the Hiring Manager/Supervisor or Request Initiator'}
    }),

    validations() {
        return {
          criteria: {
            requestId: {
              required,
            },            
          },
          asstCommissioner: {
                    approver: {
                        userId: { required: false },
                        approverValid: this.validateApprover
                    },
                    approvalStatus: { required: false }
                },

                divDirector: {
                        approver: {
                            userId: { 
                                required: false
                            }
                        },
                        approvalStatus: { required: false }
                },
        }
    },

    methods: {
      submit () {
        this.loading = true
        this.approversLoaded = false
        this.approvers = []
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/approver-check/${this.criteria.requestId}`)
        .then(response => {
            this.submitter = response.data.submitter.userId
            this.supervisor = response.data.supervisor.userId
        })
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/approvers/${this.criteria.requestId}`)
        .then(response => {
          this.approvers = response.data
          this.loading = false
          var self = this
          this.approvers.forEach(function(approver) {
            if (approver.approvalType === 'DD') {              
              self.divDirector = _.merge(approver)
            }
            if (approver.approvalType === 'AC') {
              self.asstCommissioner = _.merge(approver)
            }
          })
          this.approversLoaded = true      
        });          
      },

      update () {
        this.$v.asstCommissioner.$touch();
        if (this.$v.asstCommissioner.$invalid) {
            return
        }
        this.approvers = []
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/approvers`,
          {
            divisionDirector: this.divDirector,
            asstCommissioner: this.asstCommissioner
          }
        )
        .then(response => {
          this.$bvToast.toast('HRM Request Approvers Updated', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: 'success',
              appendToast: true
            });
          this.approversLoaded = false      
        });          
      },

      validateApprover() {
          let ac = this.asstCommissioner?.approver?.userId.toUpperCase()
          return !((ac === this.supervisor) || (ac === this.submitter))
              || (this.divDirector?.approver?.userId.toUpperCase() !== ac)
      },
    }
  }
</script>